var $dccfd203869307b6$exports = {};
$dccfd203869307b6$exports = {
    "actions": `M\u{171}veletek`,
    "hideButtonLabel": `Mutass kevesebbet`,
    "noTags": `Egyik sem`,
    "showAllButtonLabel": (args, formatter)=>`Az \xf6sszes megjelen\xedt\xe9se (${formatter.number(args.tagCount)})`
};


export {$dccfd203869307b6$exports as default};
//# sourceMappingURL=hu-HU.mjs.map
